var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8196 7.194C20.1054 8.65511 20.051 10.1624 19.6605 11.5991C19.27 13.0358 18.554 14.3634 17.5678 15.479C15.502 17.789 12.8291 18 10 18C7.17103 18 4.48906 17.789 2.42932 15.479C1.44404 14.3629 0.728762 13.0352 0.338819 11.5985C-0.0511252 10.1619 -0.10529 8.65489 0.180514 7.194C1.52479 6.89104 2.92675 6.96634 4.23082 7.41152C5.53489 7.8567 6.69007 8.65437 7.56817 9.716C8.80905 11.1086 9.64943 12.8113 10 14.643C10.3465 12.8113 11.1847 11.1082 12.4249 9.716C13.3046 8.65442 14.4611 7.85691 15.7662 7.41179C17.0713 6.96666 18.4742 6.89129 19.8196 7.194ZM10 0C8.03785 1.38389 6.69167 3.47703 6.2467 5.836C7.30625 6.40792 8.25867 7.15903 9.06171 8.056C9.39827 8.43194 9.71163 8.828 10 9.242C10.2876 8.82755 10.6003 8.43114 10.9364 8.055C11.7412 7.15668 12.6957 6.40455 13.7574 5.832C13.3113 3.47354 11.9635 1.38161 10 0Z",
    fill: "#6C59DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendAct);
export default __webpack_public_path__ + "static/media/trendAct.ad42b05f9f082bb5f1e432dedd6f67d1.svg";
export { ForwardRef as ReactComponent };